import type { GiftGrant } from '../CRM/Responses/ManualNotificationResponse';
import Model from './Model';

enum NotificationCycle {
    Daily = 'daily',
    Weekly = 'weekly',
    Monthly = 'monthly',
    Yearly = 'yearly',
}

type NotificationType = Readonly<{
    id: number;
    admin_id: number | null;
    target_user_id: number | null;
    title: string;
    content: string;
    channels: string[] | null;
    reward_type: string | null;
    reward_label: string | null;
    reward_value: string | null;
    reward_reference_id: number | null;
    reward_currency: string | null;
    gift_grant: GiftGrant | null;
    reward_cta: string | null;
    reward_reason: string | null;
    reward_status: string | null;
    reward_status_changed_at: string | null;
    reward_expires_at: string | null;
    is_active: boolean;
    last_sent: string | null;
    start_date: string;
    cycle: NotificationCycle;
    cycle_days: number[] | null;
    left_to_deliver: number;
    end_date: string | null;
    deliver_time: string;
    pinned_hours: number;
    created_at: string | null;
    updated_at: string | null;
}>;

export default class ManualNotification extends Model {
    readonly id: number;
    readonly admin_id: number | null;
    readonly target_user_id: number | null;
    readonly title: string;
    readonly content: string;
    readonly channels: string[] | null = null;
    readonly reward_type: string | null;
    readonly reward_label: string | null;
    readonly reward_value: string | null;
    readonly reward_reference_id: number | null;
    readonly reward_currency: string | null;
    readonly gift_grant: GiftGrant | null = null;
    readonly reward_cta: string | null;
    readonly reward_reason: string | null;
    readonly reward_status: string | null;
    readonly reward_status_changed_at: string | null;
    readonly reward_expires_at: string | null;
    readonly is_active: boolean = false;
    readonly last_sent: string | null;
    readonly start_date: string;
    readonly cycle: NotificationCycle = NotificationCycle.Daily;
    readonly cycle_days: number[] | null = [];
    readonly left_to_deliver: number = 0;
    readonly end_date: string | null;
    readonly deliver_time: string = '00:00:00';
    readonly pinned_hours: number = 0;
    readonly created_at: string | null;
    readonly updated_at: string | null;

    constructor(response: Partial<NotificationType>) {
        super();
        this.assignDataToProps(response, [
            'id',
            'admin_id',
            'target_user_id',
            'title',
            'content',
            'channels',
            'reward_type',
            'reward_label',
            'reward_value',
            'reward_reference_id',
            'reward_currency',
            'gift_grant',
            'reward_cta',
            'reward_reason',
            'reward_status',
            'reward_status_changed_at',
            'reward_expires_at',
            'is_active',
            'last_sent',
            'start_date',
            'cycle',
            'cycle_days',
            'left_to_deliver',
            'end_date',
            'deliver_time',
            'pinned_hours',
            'created_at',
            'updated_at',
        ]);
    }
}
